import React from 'react';
import $ from 'jquery';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import InputComponent from '../../shared_components/InputComponent';
import SelectComponent from '../../shared_components/SelectComponent';
import InformationBoxComponent from '../../shared_components/InformationBoxComponent';

@observer
class ComparisonLoanpartComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setLoanpart = this.setLoanpart.bind(this);
    this.setLoanparts = this.setLoanparts.bind(this);
    this.setloanpartsPostData = this.setloanpartsPostData.bind(this);
    this.resetFixedRateTermPostData = this.resetFixedRateTermPostData.bind(this);
    this.showTextBox = this.showTextBox.bind(this);
  }

  componentWillMount() {
    this.setLoanpartPostDataObject();
  }

  /*
  * Setup post data
  * */

  /* Set loanpart object, loanpartDuration is in months */
  setLoanpartPostDataObject() {
    const { loanpartsPostData, getFixedRateTerms } = this.props.ComparisonFormData;

    loanpartsPostData[this.props.index] = {
      gross: '',
      frt: '',
      loanpartDuration: '360',
      mortgageType: '6',
    };

    getFixedRateTerms();
  }

  setLoanpart(event) {
    this.props.ComparisonFormData.setLoanpart(event, this.props.index);
  }

  setLoanparts(event) {
    /* Modify loanpart for given index */
    this.props.ComparisonFormData.setLoanparts(event, this.props.index);
  }

  setloanpartsPostData(event) {
    const {
      loanpartsPostData,
      firstLabelId,
      secondLabelId,
      firstLabelName,
      secondLabelName,
      getFixedRateTermsForLabel,
    } = this.props.ComparisonFormData;
    loanpartsPostData[this.props.index][event.target.name] = Number(event.target.value);

    /* Get fixed rate terms when changing mortgageType */
    if (event.target.name === 'mortgageType') {
      getFixedRateTermsForLabel(this.props.index, firstLabelId, firstLabelName).then(() => {
        getFixedRateTermsForLabel(this.props.index, secondLabelId, secondLabelName);
      });

      this.resetFixedRateTermPostData(loanpartsPostData, this.props.index, 'Maak aub een keuze');
    }

    if (event.target.name === 'loanpartDuration') {
      this.resetFixedRateTermPostData(loanpartsPostData, this.props.index, 'Maak aub een keuze');
    }

    if (event.target.name === 'frt') {
      this.props.ComparisonFormData.fixedRateTerm = Number(event.target.value);
      getFixedRateTermsForLabel(this.props.index, firstLabelId, firstLabelName);
      getFixedRateTermsForLabel(this.props.index, secondLabelId, secondLabelName);
    }
  }

  resetFixedRateTermPostData(loanpartsPostData, index, text) {
    loanpartsPostData[index].frt = '';
    $(`.frt-${index} select[name=frt]`)
      .siblings('.text')
      .text(text);
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const {
      mortgageTypes,
      loanpartsPostData,
      intersectedRateTerms,
      loanpartDurationLabels,
    } = this.props.ComparisonFormData;

    const {
      errorFieldKeys,
    } = this.props.ComparisonFormData;

    const currencyEnabled = true;
    const { frt, loanpartDuration, mortgageType } = loanpartsPostData[this.props.index];
    const { informationBoxData } = this.props.InformationBoxData;

    let frtLabels = [];

    /* FixedRateTerm  can never be higher than loanpartDuration */
    if (intersectedRateTerms.length > this.props.index) {
      frtLabels = intersectedRateTerms[this.props.index];
    }

    return (
      <div>
        <div className="row columns">
          <div className="columns">
            <label htmlFor="leningdeel">Leningdeel {this.props.index + 1} </label>
          </div>
        </div>
        <div className="comparison-form__loanpart columns row">
          <div className="columns medium-21">
            <InputComponent
              value={this.props.value}
              onChangeHandler={this.setLoanpart}
              placeholder={'Hoogte leningdeel'}
              label={'Hoogte leningdeel'}
              currency={currencyEnabled}
              onBlurHandler={this.setLoanparts}
            >
              <InformationBoxComponent
                classNames="info-box-input"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.loanPartValue, event); }}
              />
            </InputComponent>
          </div>
          <div className="columns medium-21">
            <SelectComponent
              labels={mortgageTypes}
              name="mortgageType"
              onChangeHandler={this.setloanpartsPostData}
              selected={mortgageType}
              label={'Aflosvorm'}
            >
              <InformationBoxComponent
                classNames="info-box-select"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.mortgageType, event); }}
              />
            </SelectComponent>
          </div>
          <div className="columns medium-21">
            <SelectComponent
              labels={loanpartDurationLabels}
              name="loanpartDuration"
              onChangeHandler={this.setloanpartsPostData}
              selected={loanpartDuration}
              classNames={`loanpart-duration-${this.props.index}`}
              label={'Looptijd leningdeel'}
            >
              <InformationBoxComponent
                classNames="info-box-select"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.loanPartDuration, event); }}
              />
            </SelectComponent>
          </div>
          <div className="columns medium-21">
            <SelectComponent
              errorFieldKeys={errorFieldKeys}
              labels={frtLabels}
              name="frt"
              onChangeHandler={this.setloanpartsPostData}
              selected={frt}
              classNames={`frt-${this.props.index}`}
              label={'Rentevaste periode'}
            >
              <InformationBoxComponent
                classNames="info-box-select"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.frtPeriod, event); }}
              />
            </SelectComponent>
          </div>
        </div>
      </div>
    );
  }
}

ComparisonLoanpartComponent.propTypes = {
  ComparisonFormData: PropTypes.shape({
    firstLabelId: PropTypes.number,
    secondLabelId: PropTypes.number,
    firstLabelName: PropTypes.string,
    secondLabelName: PropTypes.string,
    fixedRateTerm: PropTypes.number,
    defaultInterest: PropTypes.number,
    getFixedRateTermsForLabel: PropTypes.func,
    getFixedRateTerms: PropTypes.func,
    setLoanpart: PropTypes.func,
    setLoanparts: PropTypes.func,
    loanpartDurationLabels: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    mortgageTypes: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    intersectedRateTerms: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
      PropTypes.shape({}),
    ]),
    loanpartsPostData: PropTypes.arrayOf(PropTypes.shape({})),
    labelsInterests: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
  index: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({
      header: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
};

ComparisonLoanpartComponent.defaultProps = {
  InformationBoxData: {
    informationBoxData: {
      header: '',
      text: '',
    },
  },
  ModalData: {
    openModal: () => {},
  },
  ComparisonFormData: {
    firstLabelId: 0,
    secondLabelId: 0,
    firstLabelName: '',
    secondLabelName: '',
    fixedRateTerm: 0,
    defaultInterest: 0,
    getFixedRateTermsForLabel: () => {},
    getFixedRateTerms: () => {},
    setLoanpart: () => {},
    setLoanparts: () => {},
    loanpartDurationLabels: [],
    mortgageTypes: [],
    intersectedRateTerms: [],
    loanpartsPostData: [],
    labelsInterests: [],
  },
  index: 0,
  value: 0,
};

export default inject('ComparisonFormData', 'InformationBoxData', 'ModalData')(ComparisonLoanpartComponent);
